export type DataLoadState = {
  error: ErrorType | null;
  loading: boolean;
};

export const initialDataLoadState: DataLoadState = {
  error: null,
  loading: false,
};

export type ErrorType = {
  message: string;
};
